/**
 * Written by Kieran
 * Card animation mixin
 * For toggling cards open and closed state
 */

import 'gsap'
const toggleTime = 0.35;

export default {
  methods: {
    onToggleEnter(el, done) {
      TweenMax.from(el, toggleTime, {
          ease: Expo.easeOut,
          height: 0,
          immediateRender: true,
          onComplete: done
        }
      )
    },
    onToggleLeave(el, done) {
      TweenMax.to(el, toggleTime, {
        ease: Expo.easeOut,
        height: 0,
        immediateRender: true,
        onComplete: done
      })
    }
  },
  computed: {
    computedAuto() {
      let self = this;
      if (self.model.customDate || self.isInputExpanded) {
        return 'auto'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CardAnimationMixin/index.js